package cc.bluepeak.clubmanager.site.styles

import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import org.jetbrains.compose.web.css.cssRem

val CardStyle = CssStyle {
    base {
        Modifier.borderRadius(Theme.shapes.medium).backgroundColor(colorMode.toSitePalette().surface)
    }
}

val PaddedCardStyle = CssStyle {
    base {
        Modifier.borderRadius(Theme.shapes.medium).backgroundColor(colorMode.toSitePalette().surface)
            .padding(1.cssRem)
    }
    Breakpoint.SM {
        Modifier.padding(3.cssRem)
    }
}

val SecondaryCardStyle = CssStyle {
    base {
        Modifier.borderRadius(Theme.shapes.medium).backgroundColor(colorMode.toSitePalette().surfaceVariant)
    }
}